import React, { useState, useEffect } from "react"; // Import necessary React hooks
import { Link } from "react-router-dom"; // Import Link component for navigation
import { oneKlicks } from "../SDK/oneclick"; // Import the oneKlicks API utility
import { generateToken } from "../Uitiles/generateToken"; // Import the token generation utility
import { useNavigate } from "react-router-dom"; // Import useNavigate for programmatic navigation
import '../assets/styles/dashboard.css';


const LoginScreenAdmin = () => {
    // State variables for username, password, error message, and animation visibility
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState(false);
    const [showAnimation, setShowAnimation] = useState(false); // State for animation visibility
    const navigate = useNavigate(); // Initialize navigate function

    // Effect to check for an existing token in localStorage
    useEffect(() => {
        const token = localStorage.getItem('token'); // Retrieve token from localStorage
        if (token) {
            navigate("/admin/dashboard"); // Redirect to dashboard if token exists
        }
    }, [navigate]); // Dependency array includes navigate to avoid stale closures

    // Function to handle the login form submission
    const handleLogin = async (e) => {
        e.preventDefault(); // Prevent default form submission behavior

        const tableSchema = ""; // Set table schema (not used in this case)
        const tableName = "admin"; // Define the table name for login
        const conditions = { username, password }; // Create conditions for querying the database
        const orderBy = "id ASC"; // Define order for retrieved data

        try {
            // Attempt to read login data from the database
            const logindata = await oneKlicks.read(tableSchema, tableName, conditions, orderBy);
            if (logindata.success) {
                // If login is successful
                console.log(logindata.data[0]);
                localStorage.setItem('admin', logindata.data[0]); // Store admin data in localStorage
                const token = generateToken(logindata.data[0].username, logindata.data[0].id); // Generate token
                const data = { token: token }; // Prepare data for updating token in the database
                const condition = { id: logindata.data[0].id }; // Define condition for updating token

                // Attempt to update the token in the database
                const updatetoken = await oneKlicks.update(tableSchema, tableName, data, condition);
                if (updatetoken.success) {
                    // If token update is successful
                    localStorage.setItem('token', token); // Store token in localStorage
                    localStorage.setItem('userId', logindata.data[0].id); // Store user ID in localStorage
                    setErrorMessage(false); // Clear error message state
                    setShowAnimation(true); // Show animation on successful login
                    setTimeout(() => {
                        navigate("/admin/dashboard"); // Redirect to dashboard after 5 seconds
                    }, 5000);
                }
            } else {
                // If login fails, show error message
                setErrorMessage(true); // Set error message state
                setShowAnimation(true); // Show animation on failure
                setTimeout(() => {
                    setShowAnimation(false); // Hide animation after 5 seconds
                }, 5000);
            }
        } catch (error) {
            // Catch any errors during the login process
            setErrorMessage(error.response?.data?.message || 'Login failed. Please try again.'); // Set error message state
            setShowAnimation(true); // Show animation on catch
            setTimeout(() => {
                setShowAnimation(false); // Hide animation after 5 seconds
            }, 5000);
        }
    };

    return (
        <main id="dc-main" className="dc-main dc-haslayout" style={{ marginTop: '50px' }}>
            <div className="container">
                <div className="dc-haslayout dc-haslayout page-data dc-parent-section dc-disabled">
                    <div className="main-page-wrapper">
                        <div className="row">
                            <div className="col-lg-6 col-md-12 login images" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                <img
                                    decoding="async"
                                    alt="img description"
                                    src="//css.meddylist.com//wp-content/uploads/2019/08/img-01-1.png"
                                    style={{ maxWidth: '80%', maxHeight: '100%' }}
                                />
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="dc-modalcontent modal-content login_bodey">
                                    <div className="dc-loginformholds">
                                        <strong className="dc-logo">
                                            <Link to="/">
                                                <img
                                                    className="amsvglogo"
                                                    src="//css.meddylist.com//wp-content/uploads/2024/11/Untitled-1.png"
                                                    alt="MeddyList - Find Trusted Doctors &amp; Hospitals Near You"
                                                />
                                            </Link>
                                        </strong>
                                        <div className="dc-loginheader">
                                            <span>Login</span>
                                        </div>
                                        <form onSubmit={handleLogin}>
                                            <fieldset style={{ border: 'none' }}>
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        name="username"
                                                        className="form-control"
                                                        placeholder="Username"
                                                        value={username}
                                                        onChange={(e) => setUsername(e.target.value)} // Update username state on input change
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        type="password"
                                                        name="password"
                                                        className="form-control"
                                                        placeholder="Password"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)} // Update password state on input change
                                                    />
                                                </div>
                                                <div className="dc-logininfo">
                                                    <span className="dc-checkbox">
                                                        <input id="dc-login" type="checkbox" name="rememberme" />
                                                        <label htmlFor="dc-login">Keep me logged in</label>
                                                    </span>
                                                    <button type="submit" className="dc-btn do-login-button">
                                                        Login
                                                    </button>
                                                </div>
                                            </fieldset>
                                            {errorMessage && <div className="error-message">{errorMessage}</div>} {/* Display error message if it exists */}
                                        </form>
                                        <div className="dc-loginfooterinfo">
                                            <a href="#" className="dc-forgot-password">Forgot password?</a>
                                        </div>
                                        {/* Animation for login success or failure */}
                                        {showAnimation && (
                                            <div className={`login-animation ${errorMessage ? 'error' : 'success'}`}>
                                                <p>{errorMessage ? "Login Failed!" : "Login Successful!"}</p>
                                                {/* You can add CSS animations or use a library here */}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default LoginScreenAdmin; // Export the component for use in other parts of the application
